import React, { Suspense,useState,useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WebDiscontinuePage from './WebDiscontinued';
import ShowSplash from './ShowSplash';
import isMobile from './MobileCheck';

function App() {

    const ANDROID = 'https://play.google.com/store/apps/details?id=com.ryzmedia.tatasky';
    const IOS = 'https://apps.apple.com/in/app/tata-play-live-tv-dth-pack/id385090000';

    const [showSplash, setShowSplash] = useState(true);

    const isRealMobile = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return /Android|iPhone|iPad|iPod|Mobi/i.test(ua);
    };

    useEffect(() => {
        if (!showSplash) {
            if (isRealMobile()) {
                if (isMobile.Android()) {
                    window.location.replace(ANDROID);
                } else if (isMobile.iOS()) {
                    window.location.replace(IOS);
                }
            }
        }
    }, [showSplash]);
    
        return (
            <>
            {showSplash ?
                 (
                     <ShowSplash onFinish={() => setShowSplash(false)} />
                 ) :
                (
                    <Router>
                        <Suspense fallback={<div>Loading...</div>}>
                            <Routes>
                                <Route path='/' element={<WebDiscontinuePage/>} />
                                <Route
                                    path="/watch-live-tv"
                                    element={
                                            <WebDiscontinuePage/>
                                    }
                                />
                            </Routes>
                            
                        </Suspense>
                     </Router>
                )
                    }
            </>
            
        );
}
export default App;
